import { Testimonial } from '../types';

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Jennifer Lewis',
    title: 'Homeowner',
    testimonial: 'Working with Harmony Home Decor transformed our living space completely. Their attention to detail and understanding of our style preferences was impressive.',
    image: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 2,
    name: 'Michael Thompson',
    title: 'Real Estate Agent',
    testimonial: 'I recommend Harmony Home Decor to all my clients who need staging services. Their designs sell homes faster and at better prices.',
    image: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 3,
    name: 'Sarah Johnson',
    title: 'Apartment Owner',
    testimonial: 'The virtual styling service saved me so much time and money. I got professional design advice without having to commit to a full redesign initially.',
    image: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  }
];